import type { FC, ReactElement } from "react"

import { ETypographyAlignment, ETypographySize, RootLoaderFallback, Typography } from "@/3514/components"
import { type IUseTranslation, useTranslation } from "@/hooks"
import { CoachingPlanCoachPage as CoachingPlanContainer } from "@/pages"

import classes from "./coach.individual-participant.styles"

type TProps = { isParticipantLoading: boolean; isPlanEnabled: boolean }
const CoachIndividualParticipantPlanTab: FC<TProps> = ({
    isParticipantLoading,
    isPlanEnabled
}: TProps): ReactElement => {
    const { t }: IUseTranslation = useTranslation()

    return ((): ReactElement => {
        if (isParticipantLoading) return <RootLoaderFallback top="25%" xsTop="45%" />

        if (!isPlanEnabled)
            return (
                <div className={classes.planTab.container()}>
                    <Typography
                        text={t("coachSide.individualParticipantPage.planTab.na")}
                        className={classes.planTab.emptyHint()}
                        size={ETypographySize.Small}
                        alignment={ETypographyAlignment.Left}
                    />
                </div>
            )

        return (
            <div className={classes.planTab.container()}>
                <CoachingPlanContainer withoutTitle />
            </div>
        )
    })()
}

CoachIndividualParticipantPlanTab.displayName = "CoachIndividualParticipantPlanTab"

export default CoachIndividualParticipantPlanTab
